import { docReady } from '../helpers/docReady';
const selectors = {
    tabWrapper: '[data-tabs]',
    trigger: '[data-tab-trigger]',
    content: 'data-tab-content',
};
const classes = {
    tabOpen: 'tab-open',
    tabClosed: 'tab-closed',
};
const initialiseTabs = (tabWrapper) => {
    Array.from(tabWrapper.querySelectorAll(selectors.trigger)).forEach((trigger) => {
        const relativeId = trigger.dataset.tabTrigger;
        const relativeContent = tabWrapper.querySelector(`[${selectors.content}="${relativeId}"]`);
        trigger.addEventListener('click', () => {
            closeAllTabs(tabWrapper);
            if (!relativeContent.classList.contains(classes.tabOpen)) {
                relativeContent.classList.remove(classes.tabClosed);
                relativeContent.classList.add(classes.tabOpen);
                trigger.classList.remove(classes.tabClosed);
                trigger.classList.add(classes.tabOpen);
            }
        });
    });
};
const closeAllTabs = (component) => {
    const contentElements = Array.from(component.querySelectorAll(`[${selectors.content}], ${selectors.trigger}`));
    contentElements.forEach((element) => element.classList.remove(classes.tabOpen));
    contentElements.forEach((element) => element.classList.add(classes.tabClosed));
};
docReady(() => {
    const tabs = Array.from(document.querySelectorAll(selectors.tabWrapper));
    tabs.forEach((component) => initialiseTabs(component));
});
